import React from 'react';
import TableRow from "../../UI/table/TableRow";
import {formatInt, formatPrice} from "../../../utilities/data/parser";
import LotLink from "../../Lots/LotLink";

const CostsRow = ({row}) => {
    const doc = row?.document;
    return (
        <TableRow>
            <td><LotLink movements={true} nrlotto={row?.nrlotto}>{row?.nrlotto}</LotLink></td>
            <td>{row?.buying_article}</td>
            <td>{row?.sales_article}</td>
            <td>{row?.client}</td>
            <td className="text-right">{formatPrice(row?.performance)}</td>
            <td className="text-right">{formatPrice(row?.costs_per_mq)}</td>
            <td className="text-right">{formatPrice(row?.sold_per_mq)}</td>
            <td className="text-right">{formatPrice(row?.diff_percentage)}</td>
            <td className="text-right">{formatPrice(row?.sold_mq)}</td>
            <td className="text-right">{formatPrice(row?.total_cost)}</td>
            <td className="text-right">{formatPrice(row?.total_profit)}</td>
            <td className="text-right">{formatPrice((row?.total_cost ?? 0) - (row?.total_profit ?? 0))}</td>
            <td className="text-right">{formatInt(row?.nrpz)}</td>
            <td>
                {doc ? (
                    <div className="flex flex-col text-xs leading-tight">
                        <span>{doc?.type?.name ?? "Documento"}</span>
                        <span>{doc?.nrdocfor} {doc?.datadocfor}</span>
                        <span>{doc?.company_name}</span>
                    </div>
                ) : null}
            </td>
        </TableRow>
    );
};

export default CostsRow;